export const UGO_FEE = 0.3;

// ============================================================================
// HISTORICAL PRICING LOCK
//
// Mirrors apps/ugo-admin/utils/calculations/src/constants.ts (this repo) and
// ugo-turbo's packages/calculations/src/constants.ts — keep
// NEW_PRICING_CUTOFF_DATE and LEGACY_UGO_FEE in sync with those. This lib is
// an independent package (no dependency on apps/ugo-admin/utils/calculations),
// so the cutoff/legacy values are necessarily duplicated here.
//
// STAGING TEST — currently 2026-07-31T00:00:00Z to validate the
// historical-pricing-lock cutoff end-to-end on staging (see ugo-turbo's
// docs/b2c-cutoff-staging-test-plan.md and -test-matrix.it.md). The value is
// committed to develop on purpose: that is how it reaches the staging
// deployment. Reset it to the placeholder / real go-live date when the test
// window closes.
//
// Must stay equal to the two sibling constants at all times — a mismatch makes
// the same reservation resolve to different pricing eras depending on which
// repo computes it:
//   - apps/ugo-admin/utils/calculations/src/constants.ts (this repo)
//   - ugo-turbo packages/calculations/src/constants.ts
export const NEW_PRICING_CUTOFF_DATE = new Date('2026-07-31T00:00:00Z');

// True legacy (pre-refactor, production) UGO fee — 25% (driver 75%),
// verified against commit 4af7d5f^. Changed to 30% (driver 70%) by that same
// commit, so pre-cutoff reservations must keep this split, not just the
// legacy rate table.
export const LEGACY_UGO_FEE = 0.25;

/**
 * True if `reservationCreationDate` (the reservation's booking timestamp) falls before
 * the new-pricing go-live — i.e. this reservation must use the legacy
 * UGO/driver split above. Omit `reservationCreationDate` for brand-new quotes, which
 * should always use the current split.
 */
export function isLegacyPricing(reservationCreationDate?: Date): boolean {
  return (
    !!reservationCreationDate &&
    reservationCreationDate < NEW_PRICING_CUTOFF_DATE
  );
}

/** Resolves the UGO fee percentage (0-100) for a reservation's booking date. */
export function resolveUgoFeePercentage(
  reservationCreationDate?: Date
): number {
  return (
    (isLegacyPricing(reservationCreationDate) ? LEGACY_UGO_FEE : UGO_FEE) * 100
  );
}
